import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const CountdownTimer = ({ deadline }) => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    isExpired: false
  });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date()?.getTime();
      const deadlineTime = new Date(deadline)?.getTime();
      const difference = deadlineTime - now;

      if (difference <= 0) {
        setTimeLeft({
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0,
          isExpired: true
        });
        return;
      }

      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((difference % (1000 * 60)) / 1000);

      setTimeLeft({
        days,
        hours,
        minutes,
        seconds,
        isExpired: false
      });
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, [deadline]);

  if (timeLeft?.isExpired) {
    return (
      <div className="bg-error/10 border border-error/20 rounded-xl p-4 md:p-6">
        <div className="flex items-center justify-center gap-3">
          <Icon name="AlertCircle" size={24} color="var(--color-error)" />
          <p className="text-base md:text-lg font-medium text-error">
            신청 마감되었습니다
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gradient-to-br from-primary/10 to-accent/10 border border-primary/20 rounded-xl p-4 md:p-6 lg:p-8">
      <div className="flex items-center justify-center gap-2 mb-3 md:mb-4">
        <Icon name="Clock" size={20} color="var(--color-primary)" className="md:w-6 md:h-6" />
        <h3 className="text-base md:text-lg font-heading font-semibold text-foreground">
          신청 마감까지
        </h3>
      </div>
      <div className="grid grid-cols-4 gap-2 md:gap-4">
        <div className="bg-card rounded-lg p-3 md:p-4 text-center">
          <div className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-primary data-text">
            {timeLeft?.days}
          </div>
          <div className="text-xs md:text-sm caption text-muted-foreground mt-1">
            일
          </div>
        </div>

        <div className="bg-card rounded-lg p-3 md:p-4 text-center">
          <div className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-primary data-text">
            {timeLeft?.hours}
          </div>
          <div className="text-xs md:text-sm caption text-muted-foreground mt-1">
            시간
          </div>
        </div>

        <div className="bg-card rounded-lg p-3 md:p-4 text-center">
          <div className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-primary data-text">
            {timeLeft?.minutes}
          </div>
          <div className="text-xs md:text-sm caption text-muted-foreground mt-1">
            분
          </div>
        </div>

        <div className="bg-card rounded-lg p-3 md:p-4 text-center">
          <div className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-primary data-text">
            {timeLeft?.seconds}
          </div>
          <div className="text-xs md:text-sm caption text-muted-foreground mt-1">
            초
          </div>
        </div>
      </div>
    </div>
  );
};

export default CountdownTimer;